import React, { useState } from 'react';
import { Link } from "react-router-dom";
import styled from 'styled-components';
import defaultUserImg from 'images/basicimg03.png' 
import appInfoContainer from 'auth/appInfoContainer';
import { useSelector } from 'react-redux';
import { ResponsiveContainer, PieChart, Pie, Cell, Label} from 'recharts';

export default function MyTaskListHeader(props) {
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });
  
 

  return (
    (userInfo['isLogin'] === true)
    ?(
      <TodoHeaderTop>
        <User>
          <ChartWrapper> 
            <UserImg>
              {props.userImg !== undefined ? (
                <Images
                  src={
                    appInfoContainer.imagePath +
                    '/user_profile_img/' +
                    props.userImg
                  }
                />
              ) : (
                <></>
              )}
            </UserImg> 
          </ChartWrapper>
          <ul>
            <UserName>{props.name}</UserName>
            {props.achievementGoal ? <UserPurpose>{props.achievementGoal}</UserPurpose> : null}
          </ul>
        </User>
 
      </TodoHeaderTop>
    )
    :(
      <TodoHeaderTop>
        <User>
          <UserImg><img src={defaultUserImg} alt={'user profile'} /></UserImg>
          <LoginTxt>로그인을 해 주세요:)</LoginTxt>
        </User>
        <div>
          <LoginBtn to={"/social"}>로그인</LoginBtn>
        </div>
      </TodoHeaderTop>
    )
  );
}
const ChartWrapper = styled.div` 
  width: calc(100vh * (56 / 812));
  height: calc(100vh * (56 / 812));
  display: inline-block;
  margin-right: calc(100vw * (12 / 375));
  position:relative;
`
const TodoHeaderTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: calc(100vh * (23 / 812)) calc(100vw * (17 / 375));
`;
const User = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const UserImg = styled.p`
  width: calc(100vh * (56 / 812));
  height: calc(100vh * (56 / 812));
  border-radius: 100%;
  overflow: hidden;
  border: solid calc(100vw * (1 / 375)) white;
  box-sizing: content-box;
`;
const Images = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const UserName = styled.li`
  font-size: calc(100vw * (16 / 375));
  font-weight: bold;
  line-height: 1.5;
  color: #121212;
`;
const UserPurpose = styled.li`
  width: auto;
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  color: #4e4e4e;
  z-index: 0;
`;

const LoginBtn = styled(Link)`
  width: calc(100vw * (67 / 375));
  height: calc(100vw * (27 / 375));
  border-radius: calc(100vw * (5 / 375));
  border: solid 1px #e6e6e6;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
`;
const LoginTxt = styled.p`
    font-size: calc(100vw*(14/375));
    color: #4e4e4e;
`